<div type="button"
    style="text-transform: none;"
     [className]="this.currentFilter == this.filterOption ? 'px-2 btn btn-sm mr-1 mb-1 btn-'+this.bootstrapStyle : 'px-2 btn  btn-sm  mr-1 mb-1 btn-outline-'+this.bootstrapStyle">
  <ng-content>
  </ng-content>
</div>
